import {
  createReactiveState,
  createStepHandlers,
  createSubmissionHandlers,
  getStepProperties,
  getSubmissionProperties,
} from 'utilities/stateHelpers';

import SelectStatusStep from './SelectStatusStep';
import SubmitAccountStatusStep from './SubmitAccountStatusStep';
import SubmitCLV9Step from './SubmitCLV9Step';

const SELECT_STATUS_STEP = {
  title: 'Select Account Fraud Status',
  component: SelectStatusStep,
  renderPreprocess: () => {},
  renderPostprocess: () => {},
};

const SUBMIT_ACCOUNT_STATUS_STEP = {
  title: 'Apply Status',
  component: SubmitAccountStatusStep,
  renderPreprocess: () => {},
  renderPostprocess: () => {},
};

const SUBMIT_CLV9_STEP = {
  title: 'Apply CL-V9 Status',
  component: SubmitCLV9Step,
  renderPreprocess: () => {},
  renderPostprocess: () => {},
};

export const APPLY_STATUS_STEPS = Object.freeze({
  SELECT_STATUS_STEP: SELECT_STATUS_STEP,
  SUBMIT_ACCOUNT_STATUS_STEP: SUBMIT_ACCOUNT_STATUS_STEP,
  SUBMIT_CLV9_STEP: SUBMIT_CLV9_STEP,
});

const initializeState = () => {
  return {
    ...getStepProperties(APPLY_STATUS_STEPS.SELECT_STATUS_STEP),
    ...getSubmissionProperties(),
    shouldRunSubmit: false,
    accountFraudStatusVariables: {},
    mutationFailures: false,
  };
};

const applyStatusState = createReactiveState(initializeState);
const { createPropertySetter } = applyStatusState;
export const {
  resetState: resetApplyStatusState,
  stateVar: applyStatusStateVar,
  useState: useApplyStatusState,
} = applyStatusState;

export const { setNextStep } = createStepHandlers(
  applyStatusState,
  Object.values(APPLY_STATUS_STEPS),
);

export const { setSubmissionInitiated, setSubmissionCompleted } =
  createSubmissionHandlers(applyStatusState);

export const setAccountFraudStatusVariables = createPropertySetter(
  'accountFraudStatusVariables',
);
export const setShouldRunSubmit = createPropertySetter('shouldRunSubmit');
export const setMutationFailures = createPropertySetter('mutationFailures');
